<template>
  <Card class="absolute top-12 right-[100px] w-[520px] max-h-[370px] overflow-y-scroll z-[100] p-5">
    <div v-for="(notification, index) in visibleNotifications" :key="index">
      <Flex items-center justify-between class="w-full gap-3">
        <Flex items-center gap-5>
          <i class="fas fa-file-alt rounded-[500px] bg-slate-300 p-3"></i>
          <div>
            <p class="text-sm">{{ notification.msg }}</p>
            <p class="text-sm text-slate-400 mt-6">{{ formatDate(notification.createdAt) }}</p>
          </div>
        </Flex>
        <IconButton icon="fa-solid fa-xmark" @click="emit('readNotification', notification)" />
      </Flex>
      <hr v-if="index < visibleNotifications.length - 1" class="w-full my-5" />
    </div>

    <div class="text-center text-sm" v-if="notifications.length === 0">Nenhuma notificacao</div>

    <div v-if="visibleCount < notifications.length" class="text-center mt-4">
      <button class="text-blue-500 underline text-sm" @click="showMore">Mostrar mais</button>
    </div>
  </Card>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useFormat } from '@/composables/useFormat'

const { formatDate } = useFormat()

const props = defineProps({
  notifications: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['readNotification'])

const visibleCount = ref(3)

const visibleNotifications = computed(() => {
  return props.notifications.slice(0, visibleCount.value)
})

const showMore = () => {
  visibleCount.value += 3
}
</script>
